export const transformRequestDeclineOnHoldReturn = ({ returnId, payload }) => {
  return {
    returnId,
    payload: {
      decline_reason: payload.decline_reason,
    },
  }
}
